export const FILM_URL = import.meta.env.VITE_FILM_URL ?? 'https://film.adlovin.ai'
const FILM_ORIGIN = new URL(FILM_URL).origin

export type Editor = {
  call: (type: string, payload?: Record<string, unknown>, transfer?: Transferable[]) => Promise<unknown>
  close: () => void
}

export function editorUrl(threadId: string, { chat = true } = {}) {
  const query = new URLSearchParams({ app: window.location.origin, thread: threadId, chat: chat ? '1' : '0' })
  return `${FILM_URL}/?empty&norecover&fresh&${query}`
}

export function threadOfStudioFile(url: string) {
  return url.split('?')[0].split('/').pop()?.replace(/\.json$/, '') ?? ''
}

export function connectEditor(target: Window): Editor {
  const waiting = new Map<string, { resolve: (value: unknown) => void; reject: (error: Error) => void }>()

  function onMessage(event: MessageEvent) {
    if (event.origin !== FILM_ORIGIN || event.source !== target) return
    const data = event.data as { type?: string; id?: string; result?: unknown; message?: string }
    const pending = data.id ? waiting.get(data.id) : undefined
    if (!pending || !data.id) return
    waiting.delete(data.id)
    if (data.type === 'filmcraft:error') pending.reject(new Error(data.message ?? 'The editor failed.'))
    else pending.resolve(data.result)
  }

  window.addEventListener('message', onMessage)

  return {
    call(type, payload = {}, transfer = []) {
      const id = crypto.randomUUID()
      return new Promise((resolve, reject) => {
        waiting.set(id, { resolve, reject })
        target.postMessage({ type, id, ...payload }, FILM_ORIGIN, transfer)
      })
    },
    close() {
      window.removeEventListener('message', onMessage)
      for (const pending of waiting.values()) pending.reject(new Error('The editor was closed.'))
      waiting.clear()
    },
  }
}
